var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"el-fade-in"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.toTopShow),expression:"toTopShow"}],staticClass:"page-up",on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"el-icon-caret-top"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }